import React from "react";
import { Skeleton } from "@/components/ui";

const SKELETON_PILL_COUNT = 6;

export const SmartFiltersSkeleton = () => {
  return (
    <div className="relative flex gap-2">
      {[...Array(SKELETON_PILL_COUNT)].map((_, index) => (
        <Skeleton key={index} className="h-10 w-30 shrink-0 rounded-full" />
      ))}
      <div className="absolute top-0 right-0 bottom-0 w-15 border-red-500 bg-gradient-to-r from-white/0 via-white via-50% to-white"></div>
    </div>
  );
};
